import { CookieService } from './cookie';

export class GeoService {
    static get country() {
        return CookieService.getCookie('country');
    }
    static get countryCode() {
        const countryCookie = GeoService.country || 'US:::';

        return countryCookie.split(':')[0];
    }
}



// WEBPACK FOOTER //
// ./node_modules/wg5/src/services/geo.js